export const DOCUMENT_REJECTION_CODES = new Set([
  'document_schema', 'data_layer_schema', 'data_layer_limit', 'data_layer_id', 'data_layer_duplicate_id',
  'data_layer_feature_limit', 'data_layer_source_limit', 'data_layer_payload_limit', 'data_layer_payload_schema', 'data_layer_feature_count',
  'data_layer_duplicate_feature_id', 'data_layer_bounds', 'data_layer_image_geometry',
  'drawing_layer_limit', 'stroke_limit', 'stroke_point_limit', 'map_point_limit', 'map_content', 'stroke_content', 'image_content', 's_id', 's_duplicate_id',
  'i_id', 'i_duplicate_id', 'dl_id', 'dl_duplicate_id', 'local_dataset',
] as const);
export type DocumentRejectionCode = typeof DOCUMENT_REJECTION_CODES extends Set<infer Code> ? Code : never;
export class MapDocumentValidationError extends Error {
  constructor(readonly code: DocumentRejectionCode) { super(`Map document rejected: ${code}`); }
}
